import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const PositionPriceTrailLine = observer(({
  tradePlanId,
  priceToBreak,
  amount,
  size,
  scaleY,
  portalRef,
}) => {
  // idea to show trail over time
  // maybe it could just update on new candle
  // store first dataPoint when soft order is first sent.
  // this data point gets displayed at position scaleX(numberOfCandles.length -1)
  // then we watch for the candle to change to next candle, when it does, we push a new data point into array
  // now older data point is displayed at position scaleX(numberOfcandles.length - 2) and new one is at scaleX(numberOfCandles.length - 1)
  // when  the array reaches the length numberOfCandles, we need to start shifting the first item off
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
  const paused = tradePlan?.exitTactics['POSITION_PRICE_TRAIL']?.paused ?? null;

  const json = {
    Category: 'Exit Tactic',
    Type: 'Position Price Trail',
    'Break Price': ApplyRounding(Number(priceToBreak), 2),
    Amount: amount,
  };
  return (
    <>
      {scaleY ? (
        <>
          {paused ? (
            <line
              strokeDasharray={4}
              stroke={colors.red}
              strokeWidth={2}
              x1={0}
              x2={size}
              y1={scaleY(Number(priceToBreak))}
              y2={scaleY(Number(priceToBreak))}
            />
          ) : (
            <line
              stroke={colors.red}
              strokeWidth={2}
              x1={0}
              x2={size}
              y1={scaleY(Number(priceToBreak))}
              y2={scaleY(Number(priceToBreak))}
            />
          )}
          <line
            stroke={colors.red}
            strokeWidth={2}
            x1={0}
            x2={size}
            y1={scaleY(Number(priceToBreak))}
            y2={scaleY(Number(priceToBreak))}
          />
          <HoverBox
            json={json}
            topBoundary={scaleY(Number(priceToBreak)) - 2}
            bottomBoundary={scaleY(Number(priceToBreak)) + 2}
            leftBoundary={0}
            rightBoundary={size}
            portalRef={portalRef}
            size={size}
          />
        </>
      ) : null}
    </>
  );
});

PositionPriceTrailLine.propTypes = {
  priceToBreak: PropTypes.number,
  amount: PropTypes.number,
  size: PropTypes.number,
  scaleY: PropTypes.func,
  portalRef: PropTypes.object,
  tradePlanId: PropTypes.any,
};
